import React, { useState } from "react";

const BulkActionsModal = ({
  isOpen,
  onClose,
  sdataGroup,
  selectedQuestionsForBulk,
  setSelectedQuestionsForBulk,
  getSortedQuestionKeys,
  moveSelectedQuestions,
  handleBulkDelete,
}) => {
  const [searchTerm, setSearchTerm] = useState("");

  if (!isOpen) return null;

  const toggleBulkSelection = (key) => {
    setSelectedQuestionsForBulk((prev) =>
      prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key]
    );
  };

  const allKeys = getSortedQuestionKeys();
  const filteredKeys = searchTerm.trim()
    ? allKeys.filter((key) => {
        const q = sdataGroup[key];
        const text = `${q.Question_number || key} ${q.Qtitle || ""} ${q.type || ""}`.toLowerCase();
        return text.includes(searchTerm.toLowerCase());
      })
    : allKeys;

  return (
    <div
      onClick={onClose}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "rgba(0,0,0,0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: "#fff",
          padding: 20,
          borderRadius: 12,
          width: 420,
          maxHeight: "75vh",
          display: "flex",
          flexDirection: "column",
          boxShadow: "0 10px 40px rgba(0,0,0,0.3)",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 12,
          }}
        >
          <h4 style={{ margin: 0 }}>
            Bulk Actions ({selectedQuestionsForBulk.length} selected)
          </h4>
          <button
            onClick={onClose}            
            className="quota-modal-close-button"
          >
            ×
          </button>
        </div>

        {/* Search */}
        <input
          type="text"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder="Search by question number, title, or type..."
          style={{
            width: "100%",
            padding: "6px 10px",
            fontSize: 13,
            border: "1px solid #ccc",
            borderRadius: 6,
            marginBottom: 10,
            boxSizing: "border-box",
          }}
        />

        <div style={{ display: "flex", gap: 8, marginBottom: 10 }}>
          <button
            onClick={() => setSelectedQuestionsForBulk(filteredKeys)}
            style={{ fontSize: 12, padding: "4px 8px", cursor: "pointer" }}
          >
            Select All{searchTerm.trim() ? " (Filtered)" : ""}
          </button>
          <button
            onClick={() => setSelectedQuestionsForBulk([])}
            style={{ fontSize: 12, padding: "4px 8px", cursor: "pointer" }}
          >
            Clear
          </button>
        </div>

        <div
          style={{
            flex: 1,
            overflowY: "auto",
            border: "1px solid #e5e7eb",
            borderRadius: 6,
            padding: 8,
          }}
        >
          {filteredKeys.length === 0 ? (
            <div style={{ fontSize: 13, color: "#888", padding: 8, textAlign: "center" }}>
              No questions found.
            </div>
          ) : (
            filteredKeys.map((key) => {
              const q = sdataGroup[key];
              const isSelected = selectedQuestionsForBulk.includes(key);
              return (
                <div
                  key={key}
                  onClick={() => toggleBulkSelection(key)}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    padding: "6px 4px",
                    cursor: "pointer",
                    background: isSelected ? "#f0f0ff" : "transparent",
                    borderRadius: 4,
                  }}
                >
                  <input
                    type="checkbox"
                    checked={isSelected}
                    onChange={() => toggleBulkSelection(key)}
                  />
                  <span style={{ fontSize: 13 }}>
                    {q.Question_number || key} {q.type ? `(${q.type})` : ""}
                  </span>
                </div>
              );
            })
          )}
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: 12,
          }}
        >
          <div style={{ display: "flex", gap: 6 }}>
            <button
              onClick={() => moveSelectedQuestions("up")}
              style={{ fontSize: 12, padding: "6px 10px", cursor: "pointer" }}
            >
              Move Up
            </button>
            <button
              onClick={() => moveSelectedQuestions("down")}
              style={{ fontSize: 12, padding: "6px 10px", cursor: "pointer" }}
            >
              Move Down
            </button>
          </div>
          <button
            onClick={handleBulkDelete}
            style={{
              fontSize: 12,
              padding: "6px 10px",
              cursor: "pointer",
              background: "#fee2e2",
              color: "#b91c1c",
              border: "1px solid #fca5a5",
              borderRadius: 4,
            }}
          >
            Delete Selected
          </button>
        </div>
      </div>
    </div>
  );
};

export default BulkActionsModal;